export default {
	project_title: '锦田云',
	master_menu: { //左边主菜单
		menu1: '购买/续费',
		menu2: '我的云手机',
		menu3: '我的订单',
		menu4: '云盘',
		menu5: '自动化运营',
		menu6: '代理',
		menu7: '申请代理商',
		menu8: '购买激活码',
		menu9: '兑换激活码'
	},
	title_text: {
		cloud_disk_menu_title: '我的文件',
		cloud_disk_dialog_title: '文件重命名',
		Account_Management_title: '账号管理',
		Automatically_Publish_videos_title: '自动发布视频',
		Look_Task_title: '查看任务',
		Material_Center_title: '素材中心'
	},
	button: {
		login: '登录',
		login_out: '退出登录',
		register: '注册',
		delete_btn: '删除',
		rechristen: '重命名',
		download: '下载',
		Upload_files_to_cloud: '上传文件至云盘',
		transfer_cloud: '传输至云机',
		cancel: '取消',
		confirm: '确定'
	},
	check_text: {
		check_all: '全选',
		insert_filename: '插入原文件名',
		insert_serial: '插入序号',
	},
	cloud_disk_menu: {
		all: '全部',
		apk: '安装包',
		picture: '图片',
		video: '视频',
		file: '文件'
	},
	other_text: {
		cloud_storage_space: '云盘空间',
		have_already_used: '已使用',
		expand_storage_space: '扩容空间',
		edit_file_name: '编辑文件名称',
	}
}